namespace gotoAndPlay {

    export interface IVideoSettings {
        buttonClass?: string;
        iframeClass?: string;
        playingClass?: string;
        playClass?: string;
        fixedClass?: string;
        visibleClass?: string;
        featuredClass?: string;
    }

    export class Video {

        static initSelector: string = '.video';
        private static currentVideo: Video;

        settings: IVideoSettings;
        element: JQuery;
        button: JQuery;
        iframe: JQuery;
        autoplay: boolean;
        mobileDevice: boolean;
        cookieVideo: string;
        activePlayer: boolean;
        YT: any;
        videoID: string;
        players: YT.Player[] = [];
        startPosition: string;
        previousPlaying: JQuery;
        youtubeAPILoaded: boolean;
        interval: number;
        playerId: string;
        videoName: string;

        constructor(target: HTMLElement) {
            this.settings = {
                buttonClass: 'video__overlay',
                iframeClass: 'video__iframe',
                playingClass: 'is-playing',
                fixedClass: 'is-fixed',
                visibleClass: 'is-visible',
                playClass: 'video--play',
                featuredClass: 'video--featured',
            };

            this.element = $(target);
            this.mobileDevice = Helpers.isMobileDevice;
            this.autoplay = this.element.data('autoplay');
            this.button = this.element.find('.' + this.settings.buttonClass);
            this.iframe = (this.element.find('.' + this.settings.iframeClass).length) ? this.element.find('.' + this.settings.iframeClass) : this.element.find('iframe');
            this.activePlayer = false;
            this.youtubeAPILoaded = false;
            this.element.data('video', this);
            this.init();
        }

        init(): void {
            let self = this;

            if (!this.youtubeAPILoaded) {
                this.loadYoutubeAPI().done(function () {
                    this.youtubeAPILoaded = true;
                });
            }

            // onYouTubePlayerAPIReady
            (window as any).onYouTubeIframeAPIReady = () => {
                this.YT = YT;
            };

            this.button.on('click', this.loadPlayer.bind(this));
        }

        loadYoutubeAPI(): JQueryXHR {
            return Ajax.loadScript('https://www.youtube.com/iframe_api');
        }

        hasAcceptedCookies(): boolean {
            if (typeof CookieConsent !== 'undefined') {
                return CookieConsent.consent.marketing && CookieConsent.consent.statistics;
            }

            return true;
        }

        loadPlayer(event: JQuery.Event | null = null, {}: string = null): void {
            if (!this.hasAcceptedCookies()) {
                return;
            }

            if (event) {
                event.preventDefault();
            }

            if (!this.YT && typeof(YT) != 'undefined') {
                this.YT = YT;
            } else if (!this.YT) {
                setTimeout(() => {
                    this.loadPlayer(event);
                }, 200);
            }

            if (!this.playerId) {
                if (this.activePlayer && !event) {
                    this.playerId = this.videoID;
                } else {
                    this.playerId = this.element.find('.' + this.settings.iframeClass).attr('data-id');
                }
            } else if (this.players[this.playerId]) {
                this.players[this.playerId].playVideo();
            }

            if (this.YT && !this.players[this.playerId]) {
                let youtubeOptions = {
                    playerVars: {
                        enablejsapi: 1,
                        showinfo: 0,
                        rel: 0,
                    },
                    videoId: this.playerId,
                    host: 'https://www.youtube-nocookie.com',
                    events: {
                        onReady: this.onPlayerReady.bind(this),
                        onStateChange: this.onPlayerStateChange.bind(this),
                    },
                };

                this.players[this.playerId] = new YT.Player('youtube-video-' + this.playerId, youtubeOptions);
            }

            // stop other video playing on site
            if (Video.currentVideo) {
                Video.currentVideo.stopVideo();
            }
            Video.currentVideo = this;

            // Make video visible
            if (!event) {
                if (!this.activePlayer) {
                    if (!this.mobileDevice) {
                        this.element.addClass(this.settings.playClass);
                    }
                }
            } else {
                this.startPosition = '0';
                this.element.addClass(this.settings.playClass);
            }
        }

        onPlayerReady(event: YT.PlayerEvent): void {
            this.button.hide();
            if (this.activePlayer) {
                this.element.find('.' + this.settings.iframeClass).show().addClass(this.settings.visibleClass);
            }

            // set video name
            this.videoName = (event.target as any).getVideoData().title;

            // Start selected Youtube player
            this.startVideo(event.target);
        }

        onPlayerStateChange(event): void {
            if (event.data == 1) {
                this.onPlay(event);
            }
        }

        onPlay(data): void {
            // Pause other videos
            if (this.previousPlaying && this.previousPlaying != data.target) {
                this.pauseOtherVideo(this.previousPlaying);
            }

            // Add currently playing video to variable etc
            setTimeout(() => {
                this.previousPlaying = data.target;

                // Add playing class
                if (!this.mobileDevice) {
                    let iframe = $((this.previousPlaying as any).getIframe());
                    this.element.removeClass(this.settings.playingClass);
                    iframe.parents(Video.initSelector).addClass(this.settings.playingClass);
                }
            }, 300);
        }

        onEnded(data): void {
            if (this.hasNextVideo()) {
                Video.loadNextVideo(this);
            } else {
                Video.loadMoreVideos(this);
            }
        }

        hasNextVideo(): boolean {
            let id = $(this.element).data('id');
            let parent = $(this.element).parents('.broadcast');

            return ($('.video[data-id="' + id + '"]', parent).next('.video').length > 0);
        }

        static loadNextVideo(currentVideo: Video): void {
            let id = $(currentVideo.element).data('id');
            let parent = $(currentVideo.element).parents('.broadcast');
            $('.broadcast__video', parent).addClass('h-hidden');
            $('.broadcast__suggestion-item.is-playing', parent).removeClass(currentVideo.settings.playingClass);
            let nextVideo = ($('.video[data-id="' + id + '"]', parent).next().removeClass('h-hidden').data('video') as Video);
            nextVideo.loadPlayer(null, $(nextVideo.element).data('id'));
            $(nextVideo.element).addClass(currentVideo.settings.playClass);
            $('.broadcast__suggestion-item[data-id="' + id + '"]', parent).next().addClass(currentVideo.settings.playingClass);
        }

        static loadMoreVideos(thisVideo, scrollToEnd = false): void {
            let nextPageToken = $('#next-page-token');
            if (nextPageToken.val() != '') {
                let data = {
                    next_page_token: nextPageToken.val(),
                    next_page_number: nextPageToken.data('pagenum'),
                };
                $.post(ajaxPath, {
                    action: 'load_more_videos',
                    data: data,
                }, (response) => {
                    if (response['status'] == 'success') {
                        let responseHtml = response['response_html'];
                        nextPageToken.replaceWith($('#next-page-token', responseHtml));
                        $('.video:last').after($('.broadcast__videos-container', responseHtml).html());
                        $('.video.new_video').each(function () {
                            let video = new Video($(this).get(0));
                            $(this).removeClass('new_video');
                        });
                        $('.broadcast__suggestion-item:last').after($('.js-broadcast__suggestions-inner', responseHtml).html());
                        if (!scrollToEnd) {
                            Video.loadNextVideo(thisVideo);
                        }
                    }
                });
            }
        }

        startVideo(selectedVideo): void {
            // Seek to right position
            if (this.startPosition) {
                selectedVideo.seekTo(parseFloat(this.startPosition));
            }

            // Play video
            selectedVideo.playVideo();
        }

        pauseVideo(): void {
            if (this.previousPlaying) {
                this.pauseOtherVideo(this.previousPlaying);
            }
        }

        stopVideo(): void {
            if (this.previousPlaying) {
                this.stopOtherVideo(this.previousPlaying);
            }
        }

        pauseOtherVideo(lastPlayed): void {
            // Pause last playing video
            lastPlayed.pauseVideo();
            // lastPlayed.seekTo(0);
        }

        stopOtherVideo(lastPlayed): void {
            lastPlayed.stopVideo();
        }
    }

    $(document).on('enhance.video', function (event) {
        $(event.target).find(Video.initSelector).addBack(Video.initSelector).each((index: number, element: HTMLElement) => {
            let video = $(element);
            if (!video.data('videoClass')) {
                video.data('videoClass', new Video(element));
            }
        });
    });

    $(() => {
        $(document).trigger('enhance.video');
    });
}
